"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cartile = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const react_1 = __importDefault(require("react"));
const StyledEfficiencyWrapper = components_core_1.styled.div `
  border-bottom: ${props => props.withMarginBottom &&
    `1px solid ${props.theme.colors.border.default}`};

  padding-bottom: ${props => props.withMarginBottom && props.theme.size.static250};
`;
const StyledEfficiencyDetailsLinkWrapper = components_core_1.styled.div `
  margin-top: ${props => props.theme.size.static100};
`;
const StyledSubHeadlineWrapper = components_core_1.styled.div `
  margin-top: ${props => props.theme.size.static250};
`;
const StyledPriceWrapper = components_core_1.styled.div `
  margin-top: ${props => props.withMarginTop && props.theme.size.static250};
`;
const StyledCartileButtonsContainer = components_core_1.styled.div `
  margin-top: ${props => props.withMarginTop && props.theme.size.static400};
`;
const StyledContentWrapper = components_core_1.styled.div `
  margin-top: ${props => props.theme.size.static350};
  padding: 0 ${props => props.theme.size.static300};
  @media (min-width: ${components_core_1.Breakpoints.b560}px) {
    padding: 0;
  }
`;
const StyledCartile = components_core_1.styled.li `
  position: relative;
  display: flex;
  flex-direction: column;
  list-style: none;
`;
function Cartile({ ariaLabel, header, efficiency, efficiencyDetailsLink, subHeadline, prices, buttons }) {
    return (react_1.default.createElement(StyledCartile, { "data-testid": "cartile", "aria-label": ariaLabel },
        header,
        (efficiency ||
            efficiencyDetailsLink ||
            subHeadline ||
            prices ||
            buttons) && (react_1.default.createElement(StyledContentWrapper, null,
            (efficiency || efficiencyDetailsLink) && (react_1.default.createElement(StyledEfficiencyWrapper, { withMarginBottom: Boolean(subHeadline || prices) },
                efficiency,
                efficiencyDetailsLink && (react_1.default.createElement(StyledEfficiencyDetailsLinkWrapper, null, efficiencyDetailsLink)))),
            subHeadline && (react_1.default.createElement(StyledSubHeadlineWrapper, null, subHeadline)),
            prices && (react_1.default.createElement(StyledPriceWrapper, { withMarginTop: Boolean(efficiency || efficiencyDetailsLink || subHeadline) }, prices)),
            react_1.default.createElement(StyledCartileButtonsContainer, { withMarginTop: Boolean(efficiency || efficiencyDetailsLink || subHeadline || prices) }, buttons)))));
}
exports.Cartile = Cartile;
